/**
 * Anipaw brand tokens for the provider dashboard.
 *
 * Values mirror `website/resources/assets/styles.css` (anipaw.net) so the marketing site,
 * the app and this dashboard read as one brand. Keep them in sync; the MUI theme in
 * `src/theme.js` uses the same purple ramp for the authenticated surfaces.
 */
export const BRAND = {
  purple700: '#6D28D9',
  purple600: '#7C3AED',
  purple500: '#8B5CF6',
  purple400: '#A78BFA',
  purple100: '#EDE9FE',
  purple50: '#F5F3FF',
  lavenderBg: '#F4F1FB',
  ink900: '#14101E',
  ink700: '#3C3548',
  ink500: '#6B6478',
  line: '#E8E3F2',
};

/** The purple field behind every pre-dashboard screen (login, signup, application status). */
export const BRAND_GRADIENT =
  `linear-gradient(150deg, ${BRAND.purple700} 0%, ${BRAND.purple600} 52%, ${BRAND.purple500} 100%)`;

/**
 * The same soft highlight layer the marketing hero paints (`.hero::before`). Without it the
 * purple field reads as a flat block; with it the card looks lit from the corner.
 */
export const BRAND_ATMOSPHERE = [
  'radial-gradient(820px 420px at 82% 16%, rgba(255,255,255,0.13), transparent 62%)',
  'radial-gradient(640px 340px at 6% 86%, rgba(255,255,255,0.08), transparent 62%)',
].join(', ');

export const BRAND_SHADOW_CARD = '0 24px 60px rgba(20,16,30,0.22), 0 6px 18px rgba(20,16,30,0.10)';
export const BRAND_SHADOW_CTA = '0 10px 24px rgba(109,40,217,0.30)';

/** Radius that makes the square app icon read as an app icon rather than a photo. */
export const BRAND_ICON_RADIUS = '26%';

export const APP_STORE_URL = 'https://apps.apple.com/il/app/anipaw/id6789080151';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.anipaw.xyz';
export const WEBSITE_URL = 'https://anipaw.net';

/**
 * Which store button to lead with. Providers open this page on a phone about as often as on a
 * desktop, so both stores are always offered — this only decides the emphasis and the order.
 */
export const detectMobilePlatform = (userAgent) => {
  const ua =
    userAgent ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent || '');
  if (/iPad|iPhone|iPod/i.test(ua)) return 'ios';
  // iPadOS 13+ reports itself as a Mac; the touch-point count is what still gives it away.
  if (/Macintosh/i.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }
  if (/Android/i.test(ua)) return 'android';
  return null;
};
